import request from '@/service/lib/request'

/**
 * 样本展示 - 上传图片
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function create(data) {
  return request({
    url: '/api/v1/specimens',
    method: 'post',
    data
  })
}

/**
 * 样本展示 - 图片列表
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function list(params) {
  return request({
    url: '/api/v1/specimens',
    method: 'get',
    params
  })
}

/**
 * 样本展示 - 删除图片
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function remove(id) {
  return request({
    url: `/api/v1/specimens/${id}`,
    method: 'delete'
  })
}
